import * as actions from "../global/actionTypes";

export const toggleSideBar = () => ({
  type: actions.TOGGLE_SIDEBAR,
});
